import { render, staticRenderFns } from "./NewsList.vue?vue&type=template&id=0da31cd2&scoped=true&"
import script from "./NewsList.vue?vue&type=script&lang=js&"
export * from "./NewsList.vue?vue&type=script&lang=js&"
import style0 from "./NewsList.vue?vue&type=style&index=0&id=0da31cd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da31cd2",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TextWithIcon: require('/home/bitrix/frontend/components/other/TextWithIcon.vue').default})
